export default __webpack_public_path__ + "static/media/tuomin.ff5e40b3.gif";